$(document).ready(function() {
	// var selectNode = document.querySelector('.code-select-s');
	// var textNode = document.querySelector('.number-field');
	// var resultNode = document.querySelector('#result');
	// var result;
	// var updateResult = function(e) {
	// 	result = selectNode.value + textNode.value;
	// }
	// selectNode.addEventListener('change', updateResult);
	// textNode.addEventListener('input', updateResult);
	// $('body').on('submit', '.js-validate-form.double-input', function(e) {
	// 	// $(resultNode).css('color', '#f6f6f6');
	// 	resultNode.value = result;
	// })
	$('body').on('submit', '.js-validate-form', function(e) {
		if (e.isDefaultPrevented()) {
			// handle the invalid form...
		} else {
			$('.js-validate-form--send').prop('disabled', true);
			var currentForm = $(this);
			var fields = $(".js-validate-form .form-control");
			$.each(fields, function(index, elem) {
				$(elem).next('.with-errors').text('');
			})
			$.ajax({
				type: "POST",
				url: $(currentForm).attr('action'),
				data: $(currentForm).serialize(),
				dataType: 'json',
				success: function(data) {
					// console.log(data);
					if (data.status == "success") {
						console.log('ok');
						console.log('ok');
						console.log('ok');
						console.log('ok');
						console.log('ok');
						console.log('ok');
						console.log('ok');
						console.log('ok');
						console.log('ok');
						console.log('ok');
						console.log('ok');
						console.log('ok');
						// $('.js-validate-form .msg-success').removeClass('hidden');
						$('.js-validate-form input:not(.js-validate-form--send), .js-validate-form textarea').val("");
						$('.js-validate-form select').val($('.js-validate-form select option:first').val());
						$('.js-validate-form--send').prop('disabled', false);
						$.each(fields, function(index, elem) {
							$(elem).next('.with-errors').text('');
						})
						$('#valid-msg').addClass('hide');
						$('.selected-dial-code').text('');
						// $(currentForm).next('.form-message').append('<div class="js-validate-form-text-after-sending-form">' + data.text_end + '</div>');
						$(currentForm).append('<div class="js-validate-form-text-after-sending-form">' + data.text_end + '</div>'); 
						setTimeout(function() {
							var url = $(currentForm).attr('action');
							var csform = url.substr(url.lastIndexOf("=")+1);
							// $('.js-validate-form .msg-success').addClass('hidden');
							// $('.js-validate-form-text-after-sending-form').remove();
							var fullurl ='https://www.mellius.com/index.php?dir=site&page=forms&op=complete&cs='+csform;
							console.log('fullurl',fullurl);
							window.location.href = fullurl; 
						}, 1000);  
					} else {
						// console.log('f');
						var fields_db = [];
						$.each(fields, function(index, elem) {
							fields_db.push($(elem).attr('name'));
						})
						var errorsArr = Object.keys(data.errors);
						console.log('errorsArr', errorsArr);
						for (var i = 0; i < fields_db.length; i++) {
							for (var j = 0; j < errorsArr.length; j++) {
								if (fields_db[i].includes(errorsArr[j])) {
									$.each(fields, function(index, elem) {
										if (elem.name === fields_db[i]) {
											$(elem).parent().removeClass('has-success').addClass('has-error has-danger');
											$(elem).next('.with-errors').text(data.errors[errorsArr[j]]);
										}
									})
								} else if (errorsArr[j] == 'captcha') {
									$('.js-validate-form').find('#recaptcha').next('.with-errors').html('<p class="text-danger text-left">' + data.errors[errorsArr[j]] + '</p>');
								}
							}
						}
						$('.js-validate-form--send').prop('disabled', false);
					}
				}
			});
		}
		return false;
	});
	// telephone countries
	// var telInput = $("#phone"),
	// 	errorMsg = $("#error-msg"),
	// 	validMsg = $("#valid-msg");
	console.log('ff');
	var telInputs = $('.code-phone');
	$(telInputs).each(function() {
		// console.log($(this));
		// var errorMsg = $(this).next("#error-msg");
		var errorMsg = $(this).parent().find("#error-msg");
		var validMsg = $(this).next("#valid-msg");
		console.log('fz123')
		// initialise plugin
		//  detect_country - itai
		preferredCountries_array = ['IL', 'BG', 'CH'];
		var location_info_country_code = 'IL';
		// var location_info.country_code = 'IL';
		preferredCountries_array.indexOf(location_info_country_code) === -1 ? preferredCountries_array.unshift(location_info_country_code) : null;
		console.log(preferredCountries_array);
		console.log(location_info_country_code);
		
		$(this).intlTelInput({
			//  initial country tracked by server --itai
			initialCountry: location_info_country_code,
			allowExtensions: true,
			formatOnDisplay: true,
			autoFormat: true,
			autoHideDialCode: true,
			autoPlaceholder: true,
			defaultCountry: "auto",
			ipinfoToken: "yolo",
			nationalMode: false,
			numberType: "MOBILE",
			//onlyCountries: ['us', 'gb', 'ch', 'ca', 'do'],
			//  detect_country - itai
			preferredCountries: preferredCountries_array,
			preventInvalidNumbers: true,
			separateDialCode: true,
			// initialCountry: "auto",
			geoIpLookup: function(callback) {
				$.get("https://ipinfo.io", function() {}, "jsonp").always(function(resp) {
					var countryCode = (resp && resp.country) ? resp.country : "";
					console.log('countryCode');
					console.log(countryCode);
					console.log(countryCode);
					console.log(countryCode);
					console.log(countryCode);
					console.log(countryCode);
					console.log(location_info_country_code);
					console.log('countryCode');
					callback(countryCode);
				});
			},
			utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.9/js/utils.js"
		});
		var reset = function() {
			$(this).removeClass("error");
			errorMsg.addClass("hide");
			validMsg.addClass("hide");
		};
		// on blur: validate
		$(this).blur(function() {
			reset();
			if ($.trim($(this).val())) {
				if ($(this).intlTelInput("isValidNumber") && (($.trim($(this).val()).length >= 9) || ($.trim($(this).val()).length <= 12))) {
					validMsg.removeClass("hide");
					console.log('fz11')
				} else {
					$(this).addClass("error");
					errorMsg.removeClass("hide");
					console.log('fz22')

				}
			}
		});
		// on keyup / change flag: reset
		$(this).on("keyup change", reset);
	})
});

function validatePhoneLength(input) {
	// Remove non-numeric characters from the input
	const digits = input.value.replace(/\D/g, "");
	// Check if the length is between 9 and 12 digits (inclusive)
	return digits.length >= 9 && digits.length <= 12;
  }